import { render } from "./HeaderLeft.vue?vue&type=template&id=3c296d1a"
import script from "./HeaderLeft.vue?vue&type=script&lang=js"
export * from "./HeaderLeft.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\pc\\Documents\\projets\\school_app_front_novation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__